import { useMutation } from '@apollo/client';
import { queries } from './queries';

const useSubmitSurvey = () => useMutation(queries.submit);

export default useSubmitSurvey;
